import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import API from './api';

const Posts = () => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                // Make an authenticated request to fetch posts
                const response = await API.get('posts/');
                setPosts(response.data);
            } catch (err) {
                console.error('Failed to fetch posts', err);
            }
        };

        fetchPosts();
    }, []);

    return (
        <div className="posts-container">
            {posts.length === 0 ? (
                <p>No posts available.</p>
            ) : (
                posts.map(post => (
                    <div key={post.id} className="post-card">
                        <div className="post-card-content">
                            <div className="post-image">
                                <img src="https://via.placeholder.com/150" alt="Post thumbnail" />
                            </div>
                            <div className="post-details">
                                <h3>{post.title}</h3>
                                <p>{post.content.slice(0, 100)}...</p>
                                <footer>By: {post.username}</footer>
                                <Link to={`/edit-post/${post.id}`} className="edit-post-button">
                                    Edit
                                </Link>
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default Posts;
